import { render, staticRenderFns } from "./ResidentialAddress.vue?vue&type=template&id=35557fa6"
import script from "./ResidentialAddress.vue?vue&type=script&lang=ts"
export * from "./ResidentialAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports